// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (forced-colors: active){.HighContrastSelection__HCSelection___23p9T{stroke:Highlight!important}.HighContrastSelection__HCSelection___23p9T,.HighContrastSelection__HCSelectionDefault___22dh4{background-color:transparent!important}.HighContrastSelection__HCSelection___23p9T,.HighContrastSelection__HCSelectionDefault___22dh4{forced-color-adjust:none}.HighContrastSelection__HCSelectionDefault___22dh4{stroke:CanvasText!important}}", ""]);
// Exports
exports.locals = {
	"HCSelection": "HighContrastSelection__HCSelection___23p9T",
	"HCSelectionDefault": "HighContrastSelection__HCSelectionDefault___22dh4"
};
module.exports = exports;
